import { render, staticRenderFns } from "./selectTransfer.vue?vue&type=template&id=32cbccab&scoped=true&"
import script from "./selectTransfer.vue?vue&type=script&lang=js&"
export * from "./selectTransfer.vue?vue&type=script&lang=js&"
import style0 from "./selectTransfer.vue?vue&type=style&index=0&id=32cbccab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cbccab",
  null
  
)

export default component.exports